import { createBrowserHistory } from 'history';
const history = createBrowserHistory();

// TODO trace history
// const origPush = history.push.bind(history);
// const origReplace = history.replace.bind(history);
// const origGo = history.go.bind(history);

// (history as any).push = (...args: any[]) => {
//   console.log('[DEBUG signout] history.push CALLED with', args);
//   console.trace('[DEBUG signout] history.push stack');
//   return origPush(...(args as [any]));
// };
// (history as any).replace = (...args: any[]) => {
//   console.log('[DEBUG signout] history.replace CALLED with', args);
//   console.trace('[DEBUG signout] history.replace stack');
//   return origReplace(...(args as [any]));
// };
// (history as any).go = (...args: any[]) => {
//   console.log('[DEBUG signout] history.go CALLED with', args);
//   console.trace('[DEBUG signout] history.go stack');
//   return origGo(...(args as [any]));
// };

// history.listen((location, action) => {
//   console.log('[DEBUG signout] history.listen', action, location.pathname + location.search);
// });

export default history;

// import { createBrowserHistory } from 'history';
// import { createReduxHistoryContext } from 'connected-react-router';

// const browserHistory = createBrowserHistory();

// const { createReduxHistory, routerMiddleware, routerReducer } = createReduxHistoryContext({
//   history: browserHistory,
// });

// export { createReduxHistory, routerMiddleware, routerReducer };
// export default browserHistory;
